var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2878_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0390096 0.5L6.21643 8.7598L0 15.4754H1.39907L6.84154 9.59578L11.2389 15.4754H16L9.47501 6.75096L15.2612 0.5H13.8621L8.8499 5.91498L4.8001 0.5H0.0390096ZM2.09644 1.53056H4.2837L13.9422 14.4446H11.755L2.09644 1.53056Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2878_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitterX);
export default __webpack_public_path__ + "static/media/ic-twitter_x.bf14eb98274681841f4d2d308c752648.svg";
export { ForwardRef as ReactComponent };